import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Route } from 'dataModels/route';
import { selectLeadNumber, selectVdn } from 'stores/quote/quote.selectors';
import {
    GenericResumeQuoteActionTypes,
    resumeQuoteActions,
} from 'stores/resume-quote/resume-quote.actions';
import { LoggingService } from 'sharedServices/logging.service';
import { setQueryParams } from 'stores/quote/quote.actions';
import { QuoteControllerService_Token } from 'shared/base/generics/injection-tokens/dependency-tokens';

@UntilDestroy()
@Injectable({
    providedIn: 'root',
})
export class ResumeQuoteService {
    public quoteController = inject(QuoteControllerService_Token);

    constructor(
        private readonly store$: Store,
        private readonly loggingService$: LoggingService,
    ) {}

    startNewQuote = (route: Route) => {
        let baseVdn: string;
        const vdn = this.store$.selectSignal(selectVdn)();
        const leadNumber = this.store$.selectSignal(selectLeadNumber)();

        console.info('Start New Quote - VDN', vdn);
        if (vdn?.baseVdn) {
            baseVdn = vdn.baseVdn;
        } else {
            console.warn('VDN is null do error handling');
            this.loggingService$.log({
                message: 'VDN is null when starting new quote from Resume Quote Process',
                level: 'Warn',
                tags: [leadNumber],
            });
        }

        this.store$.dispatch(resumeQuoteActions[GenericResumeQuoteActionTypes.NEW_QUOTE]({}));
        this.quoteController.reset(false);

        this.store$.dispatch(setQueryParams({ queryParams: { vdn: baseVdn } }));
        this.quoteController.navigate(route, null, false, { vdn: baseVdn });
    };
}
